import { Graphics } from 'pixi.js-legacy';

/**
 * Draw a dashed line (setLineDash alternative for PixiJS)
 */
export function drawDashedLine(
    graphics: Graphics,
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    dashLength: number = 10,
    gapLength: number = 10,
    color: number = 0xFFFFFF,
    alpha: number = 1,
    lineWidth: number = 2
): void {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const distance = Math.sqrt(dx * dx + dy * dy);

    if (distance === 0) return;

    const ux = dx / distance;
    const uy = dy / distance;

    graphics.lineStyle(lineWidth, color, alpha);

    let currentDistance = 0;
    let drawing = true;

    while (currentDistance < distance) {
        const segmentLength = drawing ? dashLength : gapLength;
        const endDistance = Math.min(currentDistance + segmentLength, distance);

        if (drawing) {
            const startX = x1 + ux * currentDistance;
            const startY = y1 + uy * currentDistance;
            const endX = x1 + ux * endDistance;
            const endY = y1 + uy * endDistance;

            graphics.moveTo(startX, startY);
            graphics.lineTo(endX, endY);
        }

        currentDistance = endDistance;
        drawing = !drawing;
    }
}
